import { useEffect, useState } from 'react'
import { fetchTheme } from './data/prismic'
import { ThemeProvider, Theme } from '@emotion/react'
import { mapTheme, GlobalThemeContainer } from './theme/theme.tsx'
import { AppRootCompProvider } from './AppContext.tsx'
import Scrollstory from './Scrollstory.tsx'

export interface AppProps {
  lang: string
  scrollstoryid: string
  theme: string
}

export const App = (props: AppProps) => {
  const [theme, setTheme] = useState<Theme>()

  useEffect(() => {
    const fetch = async () => {
      const themeName = props.theme && props.theme !== '' ? props.theme : 'az'

      try {
        const themeData = await fetchTheme(themeName)
        setTheme(mapTheme(themeData))
      } catch (error) {
        console.error(`Theme with name ${themeName} not found or invalid`)
      }
    }

    fetch()
  }, [props.scrollstoryid, props.lang, props.theme])

  return (
    <>
      {theme && (
        <ThemeProvider theme={theme}>
          <AppRootCompProvider>
            <GlobalThemeContainer>
              <Scrollstory
                lang={props.lang}
                scrollstoryid={props.scrollstoryid}
              />
            </GlobalThemeContainer>
          </AppRootCompProvider>
        </ThemeProvider>
      )}
    </>
  )
}
